/* Designer Plants PDP description presentation layer.
   Adds presentation classes/wrappers only; never edits product copy or claims. */
(function(){
  'use strict';

  function textOf(el){return (el&&el.textContent||'').replace(/\s+/g,' ').trim();}
  function isHeading(el){return !!el&&/^H[1-4]$/.test(el.tagName);}
  function directStrong(el){
    if(!el)return null;
    var child=el.firstElementChild;
    return child&&child.tagName==='STRONG'?child:null;
  }
  function siblingsUntilHeading(heading){
    var out=[],node=heading.nextElementSibling;
    while(node&&!isHeading(node)){out.push(node);node=node.nextElementSibling;}
    return out;
  }
  function markQuickLinks(desc){
    var candidates=desc.querySelectorAll('p,div');
    for(var i=0;i<candidates.length;i++){
      var strong=directStrong(candidates[i]);
      if(strong&&/^quick\s*links?:?/i.test(textOf(strong))){
        candidates[i].classList.add('dp-desc-quicklinks');
        break;
      }
    }
  }
  function makeUsesGrid(heading){
    heading.classList.add('dp-desc-heading','dp-desc-heading--uses');
    var nodes=siblingsUntilHeading(heading),benefits=[],introMarked=false;
    nodes.forEach(function(node){
      if(node.tagName!=='P')return;
      var strong=directStrong(node);
      if(strong){
        node.classList.add('dp-desc-benefit');
        benefits.push(node);
      }else if(!introMarked&&!node.getAttribute('style')){
        node.classList.add('dp-desc-section-intro');
        introMarked=true;
      }
    });
    if(benefits.length<2)return;
    var grid=document.createElement('div');
    grid.className='dp-desc-benefits-grid';
    grid.setAttribute('role','list');
    benefits[0].parentNode.insertBefore(grid,benefits[0]);
    benefits.forEach(function(item){item.setAttribute('role','listitem');grid.appendChild(item);});
  }
  function markCopySection(heading,type){
    heading.classList.add('dp-desc-heading','dp-desc-heading--'+type);
    var paragraphs=siblingsUntilHeading(heading).filter(function(node){return node.tagName==='P';});
    if(type==='install'){
      if(paragraphs[0])paragraphs[0].classList.add('dp-desc-install-copy');
      for(var i=1;i<paragraphs.length;i++)paragraphs[i].classList.add('dp-desc-install-resource');
    }else if(type==='setup'){
      paragraphs.forEach(function(p){p.classList.add('dp-desc-setup-copy');});
    }else if(type==='care'){
      paragraphs.forEach(function(p){p.classList.add('dp-desc-care-copy');});
    }else if(type==='proof'){
      paragraphs.forEach(function(p){p.classList.add('dp-desc-proof');});
    }
  }
  function normaliseFaq(desc,heading){
    heading.classList.add('dp-desc-heading','dp-desc-heading--faq');
    desc.querySelectorAll('div.dp-faq>details,details.dp-faq').forEach(function(detail){
      detail.classList.add('dp-desc-faq-item');
    });
  }
  function init(){
    var root=document.querySelector('[data-dp-unified-product]');
    if(!root)return;
    var desc=root.querySelector('.dp-u__description');
    if(!desc||desc.dataset.dpDescriptionUi==='1')return;
    desc.dataset.dpDescriptionUi='1';
    markQuickLinks(desc);

    Array.prototype.slice.call(desc.querySelectorAll('h2')).forEach(function(heading){
      var label=textOf(heading).toLowerCase();
      if((label.indexOf('where ')===0&&label.indexOf(' used')>-1)||label==='where it is used'||label.indexOf('where this ')===0&&label.indexOf(' works')>-1){
        makeUsesGrid(heading);
      }else if(label==='installation'||label.indexOf('installation')===0){
        markCopySection(heading,'install');
      }else if(label.indexOf('displaying ')===0||label==='styling and pairings'||label.indexOf('styling ')===0){
        markCopySection(heading,'setup');
      }else if(label==='maintenance'||label==='care and maintenance'||label.indexOf('maintenance')===0){
        markCopySection(heading,'care');
      }else if(label.indexOf('why designers')===0||label.indexOf('why commercial')===0){
        markCopySection(heading,'proof');
      }else if(label.indexOf('frequently asked questions')===0||label==='faq'||label==='faqs'){
        normaliseFaq(desc,heading);
      }
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
